























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'

@Component({
  components: {
    Card,
  }
})
export default class StorybookPeriodPickerInput extends Vue {
  form: any = {
    startTimestamp: new Date(),
    endTimestamp: new Date(),
  }
}
